import { connectCurrentRefinements } from './Connector/connectCurrentRefinement'
export { connectCurrentRefinements }
